export default "__VITE_ASSET__CVeKB1Pb__"